import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import { __awaiter, __generator } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React from 'react';
import { CenterPopup, Button } from 'antd-mobile';
import './index.less.js';
import classNames from 'classnames';
import { isArray, isFunction } from 'lodash';
import useLanguage from '../../hooks/useLangugle/index.js';

var Center = function Center(props) {
  var visible = props.visible,
    onClose = props.onClose,
    title = props.title,
    children = props.children,
    onConfirm = props.onConfirm,
    onCancel = props.onCancel,
    confirmText = props.confirmText,
    cancelText = props.cancelText,
    actions = props.actions,
    closeOnMaskClick = props.closeOnMaskClick,
    destroyOnClose = props.destroyOnClose,
    forceRender = props.forceRender,
    style = props.style,
    className = props.className,
    bodyStyle = props.bodyStyle,
    getContainer = props.getContainer;
  var CommonLocale = useLanguage('Common');
  var confirmButtonCls = classNames('ti-modal-center-footer-btn', 'ti-modal-center-footer-btn-confirm');
  var cancalButtonCls = classNames('ti-modal-center-footer-btn', 'ti-modal-center-footer-btn-cancel');
  var handleCancel = function handleCancel() {
    return __awaiter(void 0, void 0, void 0, function () {
      var isOk;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!isFunction(onCancel)) return [3 /*break*/, 2];
            return [4 /*yield*/, onCancel()];
          case 1:
            isOk = _a.sent();
            if (isOk === false) {
              return [2 /*return*/];
            }
            onClose();
            return [3 /*break*/, 3];
          case 2:
            onClose();
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  var handleConfirm = function handleConfirm() {
    return __awaiter(void 0, void 0, void 0, function () {
      var isOk;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!isFunction(onConfirm)) return [3 /*break*/, 2];
            return [4 /*yield*/, onConfirm()];
          case 1:
            isOk = _a.sent();
            if (isOk === false) {
              return [2 /*return*/];
            }
            onClose();
            return [3 /*break*/, 3];
          case 2:
            onClose();
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  var renderActionsNode = function renderActionsNode() {
    if (actions === undefined) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        key: "cancel",
        className: cancalButtonCls,
        fill: "none",
        block: true,
        onClick: handleCancel,
        loading: "auto"
      }, cancelText ? cancelText : CommonLocale.cancel), /*#__PURE__*/React.createElement(Button, {
        key: "confirm",
        className: confirmButtonCls,
        fill: "none",
        block: true,
        loading: "auto",
        onClick: handleConfirm
      }, confirmText ? confirmText : CommonLocale.confirm));
    }
    if (!isArray(actions)) {
      return null;
    }
    return actions.map(function (x) {
      return /*#__PURE__*/React.cloneElement( /*#__PURE__*/React.createElement(Button, {
        block: true,
        loading: "auto",
        className: "ti-modal-center-footer-btn",
        fill: "none"
      }, x.title), {
        key: x.key,
        disabled: x === null || x === void 0 ? void 0 : x.disabled,
        color: x === null || x === void 0 ? void 0 : x.color,
        onClick: x === null || x === void 0 ? void 0 : x.onClick
      });
    });
  };
  var handleMaskClick = function handleMaskClick() {
    if (closeOnMaskClick) {
      onClose();
    }
  };
  return /*#__PURE__*/React.createElement(CenterPopup, {
    visible: visible,
    onMaskClick: handleMaskClick,
    destroyOnClose: destroyOnClose,
    forceRender: forceRender,
    style: style,
    className: className,
    bodyStyle: bodyStyle,
    getContainer: getContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-modal-center"
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: "ti-modal-center-header"
  }, title) : null, /*#__PURE__*/React.createElement("div", {
    className: "ti-modal-center-body"
  }, children), actions === false ? null : /*#__PURE__*/React.createElement("div", {
    className: "ti-modal-center-footer"
  }, renderActionsNode())));
};

export { Center as default };
